import React, { useEffect, useState } from "react";
import "./CustomRewardPoints.css";
import RewardProgressCircle from "../RewardProgressCircle";
import { useNavigate } from "react-router-dom";
import CustomLoader from "../CustomLoader/CustomLoader";

// import Header from "../../../Layout/Header/Header";

// const CustomRewardPoints = ({ progress = 50, headerText = "Reward Points", imageSrc = Icons.free_world_tour_img, targets = [] }) => {
const CustomRewardPoints = ({
  progress,
  headerText,
  imageSrc,
  targets,
  rewardForIndividualProductFlag,
}) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    if (targets.length) {
      setIsLoading(false);
    }
  }, [targets]);
  // Calculate the left position for the percentage circle
  const leftPosition =
    progress === 0 ? `calc(${progress}% - 25px)` : `${progress}%`;

  const handleClickCard = (index, target) => {
    // if (target?.mileStoneFlag) {
    //   navigate("/my-account/reward-points/sub-categories", {
    //     state: { target },
    //   });
    // } else {
    //   const prodName = target.name.toLowerCase().replace(" ", "-");

    //   navigate(`/my-account/reward-points/${prodName}`, {
    //     state: {
    //       header_name: target.name,
    //       subCategoryId: target.id,
    //       weight: target.weight,
    //       unit: target.unit,
    //       mileStoneId: target.mileStoneId,
    //       mileStoneFlag: target.mileStoneFlag,
    //     },
    //   });
    // }
    if (target.subCategories && target.subCategories.length > 0) {
      navigate("/my-account/reward-points/sub-categories", {
        state: { target },
      });
    } else {
      // 👉 No subcategories → go directly
      const prodName = target.name.toLowerCase().replace(/\s+/g, "-");

      navigate(`/my-account/reward-points/${prodName}`, {
        state: {
          header_name: target.name,
          subCategoryId: target.id,
          weight: target.weight,
          unit: target.unit,
          mileStoneId: target.mileStoneId,
          mileStoneFlag: target.mileStoneFlag,
        },
      });
    }
  };
  return (
    <>
      {/* <Header /> */}
      <div className="reward-points-main-div">
        <div className="account-header">
          <p className="ac-header-para">{headerText}</p>
        </div>

        <div className="divider" />

        <div className="reward-point-container">
          <div className="free-world-tour-img">
            <img className="world-tour-img" src={imageSrc} alt="" />
          </div>
          <div className="targets">
            <div className="progress-bar-div">
              <p className="progress-text-para">Your Progress</p>
              <div className="progress-bar-ka-div">
                <div
                  className="progress-fill"
                  style={{ width: `${progress}%` }} // Fill based on progress
                />
                {/* <div
                  className="percentage-circle"
                  style={{ left: leftPosition }}
                >
                  <p>{progress > 10 && `${progress} %`}</p>
                </div> */}
                <p className="progress-center-text">
                  {/* {progress < 10 && `${progress} %`} */}
                  {`${progress} %`}
                </p>
                {/* <p>{progress} %</p> */}
              </div>
            </div>
            {isLoading ? (
              <>
                <div className="loaderContainer">
                  <CustomLoader />
                </div>
              </>
            ) : (
              <>
                <div className="targets-lower-div">
                  <p className="complete-target-para">Complete these Targets</p>
                  <div
                    className={`complete-targets-div ${
                      rewardForIndividualProductFlag ? "individual-grid" : ""
                    }`}
                  >
                    {targets?.map((target, index) => (
                      <div
                        key={index}
                        className={`target-product ${
                          rewardForIndividualProductFlag
                            ? "individual-target"
                            : ""
                        } `}
                        onClick={() => handleClickCard(index, target)}
                      >
                        <RewardProgressCircle progress={target.progress} />
                        <p className="product-name-paraaa">{target.name}</p>
                        <p className="product-name-para-priceee">
                          {target.weight} {target.unit}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default CustomRewardPoints;
